import {
  GET_PAYTMENT_METHODS_SUCCESS,
  GET_PAYTMENT_METHODS_LOADING,
  GET_PAYMENT_METHODS_FOR_USER_SUCCESS,
} from "../../constants/actionTypes";

const initialState = {
  paymentMethods: [],
  stripeCreds: "",
  setupIntent: {},
  walletBalance: null,
  loading: false,
  loaded: false,
};

const credentials = (state = initialState, action) => {
  switch (action.type) {
    case GET_PAYTMENT_METHODS_LOADING:
      state = {
        ...state,
        loading: action.payload,
      };
      break;

    case GET_PAYTMENT_METHODS_SUCCESS:
      state = {
        ...state,
        ...action.payload,
        loaded: true,
      };
      break;

    case GET_PAYMENT_METHODS_FOR_USER_SUCCESS:
      state = {
        ...state,
        ...action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default credentials;
